const styles = theme => ({
  root: {
    marginTop: 0,
    marginBottom: 0
  },
  title: {
    fontFamily: 'proximaNova-bold',
    fontSize: 32
  },
  subtitle: {
    padding: 0,
    marginTop: 0,
    marginBottom: 4,
    paddingTop: 0,
    fontFamily: 'proximaNova-bold',
    fontSize: 14
  },
  subtitleItalic: {
    marginTop: 14,
    marginBottom: 18,
    marginRight: '30%',
    fontSize: 13,
    fontFamily: 'proximaNova-italic',
    lineHeight: 1.25,
    color: 'rgba(134,134,134,1)'
  },
  link: {
    fontFamily: 'proximaNova-italic',
    fontSize: 14,
    cursor: 'pointer'
  },
  limiter: {
    color: 'rgba(134,134,134,1)',
    fontSize: 13
  },
  limiterRed: {
    color: theme.palette.button.red.active,
    fontSize: 13
  },
  descriptionField: {
    paddingRight: 70,
    marginTop: -26,
    fontSize: 15,
    fontFamily: 'proximaNova-regular',
  },
  icon: {
    marginTop: -4,
    marginLeft: 5
  },
  grid: {
    marginTop: 42
  },
  gridPaper: {
    height: 40,
  },
  gridPaper2: {
    marginTop: 6
  },
  button: {
    position: 'absolute',
    margin: 0,
    padding: 0,
    width: '65%',
    height: 60
  },
  pageTitle: {
    marginLeft: 18,
    marginTop: 10,
    fontSize: 14
  },
  categoryTitle: {
    marginLeft: 4,
    marginTop: 7,
    fontSize: 14,
    color: theme.palette.primary.light
  },
  input: {
    display: 'none'
  },
  paper: {
    width: 'auto',
    height: 'auto',
    maxWidth: 624,
    padding: 20,
    boxShadow: '0 1px 3px 0px rgba(180, 180, 180, .4)'
  },
  helperText: {
    color: 'rgba(160,160,160,1)',
    marginLeft: 24,
    fontSize: 14
  },
  logo: {
    marginLeft: 12,
    width: 40,
    height: 40,
    borderRadius: 20,
    objectFit: 'cover'
  },
  categoryImage: {
    marginLeft: 12,
    marginTop: 4,
    width: 35,
    height: 35,
    color: theme.palette.primary.light
  },
  menuRoot: {
    minWidth: 200,
    width: 'auto',
    height: 60
  },
  menuRootCategories: {
    minWidth: 200,
    width: 'auto',
    height: 40
  },
  menuImage: {
    width: 35,
    height: 35,
    marginTop: 4
  },
  menuImageFacebook: {
    marginTop: 2,
    width: 40,
    height: 40,
    borderRadius: 20,
    objectFit: 'cover'
  },
  menuTitle: {
    marginLeft: 6,
    marginTop: 7,
    fontSize: 14
  },
  menuTitleFacebook: {
    marginLeft: 18,
    marginTop: 12,
    fontSize: 14
  },
  lookingForTitle: {
    fontSize: 14
  },
  dividerCategories: {
    marginLeft: 58,
    marginRight: 18,
    marginTop: 5,
    marginBottom: 5,
  },
  dividerFacebookPages: {
    marginTop: 5,
    marginBottom: 5,
    marginLeft: 75,
    marginRight: 18
  },
  menuHeight: {
    maxHeight: 500,
    height: 'auto'
  },
  uploadPhoto: {
    width: '100%',
    height: 90,
    fontSize: 13,
    fontFamily: 'proximaNova-bold',
    boxShadow: 'none',
    border: 'none',
    backgroundColor: 'rgba(245,245,245,1)'
  },
  photoImage: {
    width: 'auto',
    height: 'auto',
    maxHeight: 300,
    maxWidth: 582,
    borderRadius: 4,
    boxShadow: '0 1px 3px 0px rgba(180, 180, 180, .4)'
  },
  error: {
    fontSize: 13,
    color: 'red',
    marginLeft: 5,
    marginTop: 4
  }
});

export default styles;
